import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const ForgotPassword = (store) => ({
  path: ROUTE.FORGOT_PASSWORD,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'forgotPassword',
    loadReducer: () => import('./ForgotPasswordState'),
    loadComponent: () => import('./ForgotPasswordContainer'),
  })
})

export default ForgotPassword
